import type { ReactNode } from 'react';
import styles from './styles.module.css';

/**
 * A raw technical value: an identifier, a code, a version, a digest. It is shown exactly as the service
 * sent it and is never translated; `translate="no"` also keeps browser translation away from it. A value is
 * kept whole while it fits and wraps only where it would overflow; `long` marks a digest or an address, which
 * may break at any character so that it never widens the table that holds it.
 */
export function Code({ children, block = false, long = false }: { children: ReactNode; block?: boolean; long?: boolean }) {
	if (block) {
		return (
			// One `code` in the block, so its first and last lines keep the block's inset (D184)
			<pre translate="no" className={`overflow-x-auto rounded-control bg-panel p-3 font-mono text-sm leading-relaxed text-ink ${styles.block}`}>
				<code>{children}</code>
			</pre>
		);
	}
	return (
		<code translate="no" className={long ? `${styles.code} ${styles.long}` : styles.code}>
			{children}
		</code>
	);
}
